<template>
  <v-btn
    :id="id"
    :variant="variant"
    :loading="props.loading"
    :disabled="props.disabled"
    :active-color="activeColor"
    :base-color="baseColor"
    :color="props.color"
    :elevation="props.elevation"
    :block="props.block"
    :icon="props.icon"
    v-bind="$attrs"
    :style="props.htmlStyle"
    :target="props.target"
    :href="props.href"
    :size="props.size"
    :class="['text-none', props.customClasses]"
    :to="props.to"
    :type="props.btnType"
    :value="props.value"
  >
    <slot>
      <v-icon
        v-if="props.prependIcon"
        :class="{ 'mr-1': props.text !== '' }"
        :size="props.iconSize ? props.iconSize : props.size"
      >
        {{ props.prependIcon }}
      </v-icon>
      <span :class="{ 'hide-sm': props.hideTextOnMobile }">
        {{ props.text }}
      </span>
      <v-icon
        v-if="props.appendIcon"
        :class="{ 'ml-3': props.text !== '' }"
      >
        {{ props.appendIcon }}
      </v-icon>
    </slot>
  </v-btn>
</template>

<script setup>
//note in vue3 using the prepend icon you can't change its size. so for now if the size of the icon is custom, then a default template must be sent in to override
//note the text-none class means that you dont have to specify casing, just pass the text in the way you want it to appear
import { computed } from 'vue'

const props = defineProps({
  id: String, //i dont think this id is required to be a prop but it is required on input fields so doing for consistency
  to: [Object, String], //fields without a defined default will default to null
  variant: String, //using `variant` to prep for vue3, if there is not a variant set it will default to null which is why the text color is set to white if there is no variant
  elevation: {
    type: Number,
    default: 0
  },
  href: String,
  target: String, //pretty sure this prop is gone in v3
  htmlStyle: String, //style was a reserved word...only seen this used to set a max width so far. in v3 there is an option for that so style should go away
  htmlStyleObject: String, //style was a reserved word...only seen this used to set a max width so far. in v3 there is an option for that so style should go away
  text: {
    //note in vue3 you can pass in a text prop and you wont need a slot. but for now we have to take that text value and throw it into the default slot until we are on vue3
    type: String,
    default: ''
  },
  activeColor: String,
  baseColor: {
    type: String
},
  color: {
    type: String,
    default: 'primary'
  },
  loading: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  icon: {
    type: Boolean,
    default: false
  },
  prependIcon: {
    //using `prependIcon` to prep for vue3
    type: String,
    default: ''
  },
  appendIcon: {
    //using `appendIcon` to prep for vue3
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'default'
  },
  iconSize: {
    type: String,
    default: 'default'
  },
  hideTextOnMobile: {
    type: Boolean,
    default: false
  },
  block: {
    type: Boolean,
    default: false
  },
  customClasses: {
    type: String,
    default: ''
  },
  btnType: {
    type: String,
    default: 'button'
  },
  value: String
})
const variants = ['flat', 'text', 'elevated', 'tonal', 'outlined', 'plain']
const variant = computed(() => {
  if (!variants.includes(props.variant)) {
    return 'elevated'
  }
  return props.variant
})
</script>

<style lang="scss" scoped></style>
